import React from 'react';
import { CardsSection } from 'components/layout/Section/CardsSection';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';
import { BorrowerContractualizationResponse } from 'api/quote';
import { formatDateFr } from 'shared/utils/formatDate';
import { BorrowerPricingDetails } from './BorrowerPricingDetails';

interface BorrowerQuoteDetailsProps {
  globalInfos: BorrowerContractualizationResponse;
}

export const BorrowerQuoteDetails: React.FC<BorrowerQuoteDetailsProps> = ({ globalInfos }) => {
  const { t } = useDynamicTranslation([NsKey.Common, NsKey.ActorForm, NsKey.Pricing]);

  return (
    <div className="space-y-6">
      <CardsSection title={t('COMMON.LABELS.INSURED_INFOS')}>
        <div className='p-4 rounded-xl border bg-white'>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <span className="text-sm font-medium text-gray-500">
                {t('ACTOR_FORM.PERSONAL_INFOS.LABELS.FULL_NAME')}
              </span>
              <p className="text-sm text-gray-900 font-medium">
                {globalInfos.insured.displayName}
              </p>
            </div>
            <div>
              <span className="text-sm font-medium text-gray-500">
                {t("ACTOR_FORM.PERSONAL_INFOS.LABELS.EMAIL")}
              </span>
              <p className="text-sm text-gray-900">{globalInfos.insured.email}</p>
            </div>
          </div>
        </div>
      </CardsSection>

      <CardsSection title={t('COMMON.LABELS.PRICING_DETAILS')}>
        <div className='p-4 rounded-xl border bg-white'>
          <span className="text-sm font-medium text-gray-500">
            {t('COMMON.LABELS.EXPECTED_EFFECTIVE_DATE')}
          </span>
          <p className="text-sm text-gray-900">
            {formatDateFr(globalInfos.expectedEffectiveDate, t('COMMON.LABELS.NOT_PROVIDED'))}
          </p>
        </div>
        {globalInfos.pricing && (
          <BorrowerPricingDetails
            pricing={globalInfos.pricing}
            isGroupOffer={globalInfos.quoteTabs && globalInfos.quoteTabs.length > 1}
          />
        )}
      </CardsSection>
    </div>
  );
};
